/**
 * SENTRY-INTEGRATION-01 — Exposes the Sentry frontend config to the browser.
 *
 * The DSN is publishable (safe to expose) but is stored as a runtime secret
 * `SENTRY_DSN` so it can be rotated without redeploys. This server fn reads
 * it at request time inside the handler and returns it to the React client
 * which then calls Sentry.init().
 */
import { createServerFn } from "@tanstack/react-start";

export interface SentryClientConfig {
  dsn: string | null;
  environment: string;
  release: string;
}

export const getSentryClientConfig = createServerFn({ method: "GET" }).handler(
  async (): Promise<SentryClientConfig> => {
    const dsn = process.env.SENTRY_DSN || null;
    const environment =
      process.env.SENTRY_ENVIRONMENT ||
      process.env.NODE_ENV ||
      "production";
    const release =
      process.env.SENTRY_RELEASE ||
      process.env.VITE_APP_VERSION ||
      "dev";
    return { dsn, environment, release };
  },
);